import CacheManager from '@vue-util/cacheManager';
import { IPzoObject } from '@types/definitions'; // eslint-disable-line no-unused-vars

const PZO_USER_ELIGIBLE = 'X-User-Pzo-Eligible';
const expireTimestamp = 45; // 45 mins expiration time
const isWindowDefined = typeof window !== 'undefined';

/**
 *
 * @returns {IPzoObject}
 */
export default function usePZOStorage() {
  /**
   * Function for checking if there is PZO storage for specific user
   * @param {string} userID - User ID
   * @returns {boolean} - Returns true if there is an PZO storage for a user with provided ID
   */
  function doPzoStorageExistsForThisUserId(userID) {
    /* istanbul ignore else */
    if (!isWindowDefined) return false;
    const pzoStorage = CacheManager.getPersistent(PZO_USER_ELIGIBLE);
    /* istanbul ignore else */
    if (pzoStorage?.userId !== userID) {
      CacheManager.removePersistent(PZO_USER_ELIGIBLE);
      return false;
    }
    return !!pzoStorage;
  }

  /**
   * Function for setting the pzo storage
   * @param {Object} payload - Payload object with ID and Date
   * @returns {void} - This function does not return anything
   */
  function setPzoStorage(payload) {
    /* istanbul ignore else */
    if (!isWindowDefined) return;
    CacheManager.setPersistent(PZO_USER_ELIGIBLE, payload, expireTimestamp);
  }

  return {
    doPzoStorageExistsForThisUserId,
    setPzoStorage,
  };
}
